import { RawToggle as Toggle, Translation } from '@ps/web-shared-components';
import type { ClassNameProp } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTACL_Play_Money, TXTACL_Real_Money } from './MoneyToggle.messages.json';
import styles from './MoneyToggle.scss';

interface Props extends Partial<ClassNameProp> {
  onOffToggle?: boolean;
}

const PlayMoneyToggle: React.FC<Props> = ({ onOffToggle, className }) => {
  const isPlayMoney = useSelector(select.currency.isPlayMoney);
  const {
    currency: { setPlayMoney }
  } = useDispatch<Dispatch>();

  return (
    <form className={styles.form}>
      <span
        data-testid="real-money-toggle-button"
        className={classNames(styles.real, { [className || styles.active]: !isPlayMoney })}
        onClick={() => setPlayMoney({ selected: false })}
      >
        <Translation {...TXTACL_Real_Money} />
      </span>
      <Toggle
        id="play-money-toggle"
        type="switch"
        className={styles.toggle}
        onOffToggle={onOffToggle}
        checked={isPlayMoney}
        label={
          <span className={styles.hidden}>
            <Translation {...TXTACL_Play_Money} />
          </span>
        }
        onChange={() => setPlayMoney({ selected: !isPlayMoney })}
      />
      <span
        data-testid="play-money-toggle-button"
        className={classNames(styles.play, { [className || styles.active]: isPlayMoney })}
        onClick={() => setPlayMoney({ selected: true })}
      >
        <Translation {...TXTACL_Play_Money} />
      </span>
    </form>
  );
};

PlayMoneyToggle.displayName = 'PlayMoneyToggle';

export default PlayMoneyToggle;
